// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._components-online-notice-dialog .text-indent[data-v-d8e235b4] {\n  text-indent: 2em;\n}\n._components-online-notice-dialog .btn[data-v-d8e235b4] {\n  width: 100%;\n  margin-top: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
